
import { _typeLogo } from "../../core/core";
import "./Logo.css";

export const Logo = ({
  type = _typeLogo.default,
  link = "/",
  ...props }) => {
  return (
    <a href={link} className="logo">
      <div className={`hm-body hm-body-${type}`}>
        <div className={`hm hm-${type}`}>HMREP</div>
      </div>
    </a>
  );
};  